
export class AppManager {
    public IsLoggedIn(): boolean {
        let token = this.getToken()
        return token != null;
    }
    getToken(){
        return localStorage.getItem("authToken");
    }
    setToken(sessionId:string){
        if(sessionId == null){
            localStorage.removeItem("authToken")
        }else{
            localStorage.setItem("authToken",sessionId);
        }
    }
}
let appManager = new AppManager();
export function getAppManager():AppManager{
    return appManager
}